export const tags = [
    'ReferencedImageSequence',
    'ReferencedSOPClassUID',
    'ReferencedSOPInstanceUID',
    'ReferencedFrameNumber',
    'SharedFunctionalGroupsSequence',
    'PerFrameFunctionalGroupsSequence',
    'PlanePositionSequence',
    'AnatomicRegionSequence',
    'PlaneOrientationSequence',
    'PixelMeasuresSequence',
    'PixelValueTransformationSequence',
    'ParametricMapFrameTypeSequence',
    'RealWorldValueMappingSequence',
];
